<template>
  <div>
    <h1>Game List</h1>

    <div>sorted</div>

    <div class="mt-8" v-for="date in app_list" :key="date.to">
      <div class="tw_flex_center">
        <router-link :to="date.to">
          <div class="m-4">
            <im2 class="rounded-3xl w-64" :src="date.icon" />
          </div>
          <h1 class="m-4">{{ date.name }}</h1>
          <div class="flex justify-end">
            v{{ date.ver }} - {{ moment(date.date).fromNow() }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// src\views\HomeView.vue
import { ref, onMounted } from "vue";
import moment from "moment";
// import HelloWorld from '@/components/HelloWorld.vue' // @ is an alias to /src
// import MyProgress from "@/components/MyProgress.vue";
// import { easeOut, progress } from "motion-v/es";
// import { Icon } from "@iconify/vue";
// import { motion } from "motion-v";
// import { read_todo } from "@/helper";
// import LoadingIcon from "@/components/LoadingIcon.vue";
// import TodoChart from "@/components/TodoChart.vue";
import im2 from "@/components/Img2.vue";

// const url = "https://api-get-todos-baqco6xtzq-uc.a.run.app";
// const loaded = ref(false);
// const todo = ref(0);
// const doing = ref(0);
// const done = ref(0);
// const skip = ref(0);
// const reject = ref(0);
// const unknown = ref(0);
// const is_show_progress = ref(false);

// function get_precent() {
//   let total = todo.value;
//   // total += doing.value;
//   total += done.value;
//   // total += skip.value;
//   // total += reject.value;
//   if (total == 0) return 0;
//   if (total == Number.NaN) return 0;

//   let complete = done.value;
//   // complete += skip.value;

//   let precent = complete / total;
//   // console.log("get_precent", complete, total, precent);

//   return precent;
// }

// function get_precent_text() {
//   var v = get_precent();
//   v = Math.round(v * 100);
//   return `${v}%`;
// }

interface APP_DATA {
  name: string;
  ver: number;
  date: string;
  to: string;
  icon: string;
}
const raw_list: APP_DATA[] = [
  //
  {
    name: "V Puzzle Girls",
    ver: 28,
    date: "2026-01-24",
    to: "/jsmg",
    icon: "/jsmg/app_icon_2.jpg",
  },
  {
    name: "Block Blast Girls",
    ver: 52,
    date: "2026-02-20",
    to: "/bbg",
    icon: "/bbg/app_icon.jpg",
  },
  {
    name: "Jigsaw Anime Girl",
    ver: 29,
    date: "2026-03-20",
    to: "/jag",
    icon: "/jag/app_icon_2.jpg",
  },
  {
    name: "Jewel Master Girl",
    ver: 53,
    date: "2026-03-09",
    to: "/jmg",
    icon: "/jmg/app_icon.jpg",
  },
  {
    name: "Match3 Master Girl",
    ver: 25,
    date: "2026-04-20",
    to: "/mg",
    icon: "/mmg/mmg_loop_quad_gif.webp",
  },
];
const app_list = ref<APP_DATA[]>([]);

onMounted(async () => {
  //
  document.title = "NadoProject";

  raw_list.sort((a, b) => {
    if (a.date == b.date) return 0;
    if (a.date > b.date) return -1;
    return 1;
  });

  for (var data of raw_list) {
    app_list.value.push(data);
  }

  // try {
  //   const res = await Helper.web_get(url);
  //   console.log("res", res.data);

  //   loaded.value = true;

  //   const data = read_todo(res.data);
  //   todo.value = data.todo;
  //   done.value = data.done;

  //   // 남은거 검사
  //   for (var k in res.data) {
  //     if (k == "key") continue;
  //     if (k == "date") continue;
  //     if (k == "diff") continue;
  //     unknown.value++;
  //   }

  //   if (unknown.value > 0) {
  //     console.error("not proc item", res.data);
  //   }
  // } catch (err) {
  //   const e = err as Error;
  //   console.log("catch", e.message);
  // }
});

// export default defineComponent({
//   name: 'HomeView',
//   components: {
//     HelloWorld
//   }
// })
</script>
